<template>
  <div>
    <div v-show="!isLoaded">
      <spin-loader />
    </div>
    <div v-show="isLoaded">
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <div v-if="hasPermissionToRead">

            <b-card
              id="cardFreight"
              class="mb-0"
              no-body
            >
              <div class="mr-2 ml-2 mt-1 mb-1">
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <div>
                      <b-form-group
                        label="Exibir"
                        label-for="idSearchBox"
                        class="mb-0"
                      >
                        <v-select
                          id="idSearchBox"
                          v-model="perPage"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="perPageOptions"
                          :clearable="false"
                          class="per-page-selector d-inline-block"
                        >
                          <span slot="no-options">Não há opções para essa quantidade.</span>
                        </v-select>
                      </b-form-group>
                    </div>
                    <b-form-input
                      v-model.lazy="searchQuery"
                      placeholder="Buscar"
                      type="text"
                      class="d-inline-block mt-2 ml-1"
                    />
                  </b-col>
                </b-row>
              </div>
              <b-table
                class="position-relative"
                primary-key="id"
                responsive
                show-empty
                striped
                hover
                empty-text="Não existem fretes cadastrados."
                :items="data"
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                @row-clicked="edit"
              >
                <template #cell(field_id)="field">
                  <b-media vertical-align="center">
                    <b-link
                      class="font-weight-bold d-block text-nowrap"
                    >
                      #{{ field.item.id }}
                    </b-link>
                  </b-media>
                </template>

                <template #cell(field_name)="field">
                  <span class="font-weight-bold text-nowrap">
                    {{ field.item.name }}
                  </span>
                </template>

                <template #cell(field_percentage)="field">
                  <span class="font-weight-bold text-nowrap">
                    {{ field.item.value | formatNumber(2) }} %
                  </span>
                </template>

                <template #cell(field_actions)="field">
                  <div v-if="hasPermissionToDelete">
                    <b-button
                      class="btn-icon rounded-circle"
                      variant="flat-info"
                      size="md"
                      @click="showConfirmOrCancelDelete(field.item)"
                    >
                      <svg-icon
                        type="mdi"
                        size="18"
                        :path="mdiTrashCanOutline"
                      />
                    </b-button>
                  </div>
                </template>
              </b-table>

              <div class="mx-2 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalItems"
                      :per-page="perPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>

                  </b-col>
                </b-row>
              </div>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <validation-observer
      v-slot="{ handleSubmit, invalid }"
      ref="refFormObserver"
    >
      <b-modal
        id="idModalColorName"
        ref="modalColorName"
        no-close-on-backdrop
        no-close-on-esc
        centered
        cancel-variant="outline-primary"
        :hide-footer="isCreate ? false : !hasPermissionToUpdate"
        :ok-disabled="invalid"
        @ok="handleSubmit(save)"
        @cancel="cancel()"
        @hidden="cancel()"
      >
        <template #modal-title>
          Cadastro de Frete
        </template>
        <template #modal-cancel>
          Cancelar
        </template>
        <template #modal-ok>
          Salvar
        </template>
        <b-form
          class="mt-1"
        >
          <b-row>
            <b-col>
              <validation-provider
                #default="validationContext"
                name="region"
                :rules="{
                  required: true,
                }"
              >
                <b-form-group
                  label="Região"
                  label-for="region"
                >
                  <b-form-input
                    id="region"
                    v-model="freight.name"
                    name="region"
                    :readonly="isCreate ? false : !hasPermissionToUpdate"
                    placeholder="Região"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                #default="validationContext"
                name="percentage"
                :rules="{
                  required: true,
                }"
              >
                <b-form-group
                  label="Porcentagem"
                  label-for="percentage"
                >
                  <b-input-group>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                    <cleave
                      id="percentage"
                      v-model="percentage"
                      name="percentage"
                      :class="!getValidationState(validationContext) ? 'form-control is-invalid' : 'form-control'"
                      :options="options.percentage"
                      :state="getValidationState(validationContext)"
                      :readonly="isCreate ? false : !hasPermissionToUpdate"
                      placeholder="0,00"
                    />
                  </b-input-group>
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>

            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>
    <div>
      <b-button
        id="addItemBtn"
        v-b-tooltip.hover
        v-b-modal.idModalColorName
        class="btn-icon rounded-circle m-3"
        variant="primary"
        size="md"
        :disabled="!hasPermissionToWrite"
        title="Adicionar estimativa de frete"
        @click="setIsCreate(true)"
      >
        <svg-icon
          type="mdi"
          :path="mdiPlus"
        />
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupText,
  BRow,
  BCol,
  BButton,
  BTable,
  BPagination,
  BMedia,
  BLink,
  BModal,
  VBModal,
  VBTooltip,
} from 'bootstrap-vue'

import {
  mdiPlus,
  mdiCogOutline,
  mdiTrashCanOutline,
} from '@mdi/js'

import {
  useToast,
} from 'vue-toastification/composition'

import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import {
  required,
  confirmed,
} from '@validations'

import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import SvgIcon from '@jamescoyle/vue-icon'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import syslic from '@/syslic'
import SpinLoader from '@/components/spinloader/SpinLoader.vue'
import formatNumber from '@/components/utils/filters/formatNumber'
import SyncLoad from '@/components/utils/syncLoad'

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BInputGroup,
    BInputGroupText,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BMedia,
    BLink,
    BModal,
    SpinLoader,
    SvgIcon,
    vSelect,
    Cleave,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    VBModal,
    'b-tooltip': VBTooltip,
  },
  filters: {
    formatNumber,
  },
  data() {
    const perPage = 10
    const totalItems = 0
    const currentPage = 1
    const searchQuery = ''
    const sortBy = 'name'
    const isSortDirDesc = false
    const perPageOptions = [10, 25, 50, 100]

    const tableColumns = [
      {
        key: 'field_id',
        label: 'ID',
        thStyle: { width: '10%' },
      },
      {
        key: 'field_name',
        label: 'Região',
      },
      {
        key: 'field_percentage',
        label: 'Porcentagem',
      },
      {
        key: 'field_actions',
        label: '',
        thStyle: { width: '5%' },
      },
    ]

    const data = []

    const freight = {
      name: '',
      value: 0.00,
    }

    const isCreate = false

    const isLoaded = false
    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('freight')

    syncLoad.onReady(() => {
      this.isLoaded = true
    })

    const isAdd = true

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(this.freight)

    const options = {
      percentage: {
        numeral: true,
        numeralDecimalScale: 2,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }

    return {
      required,
      confirmed,
      refFormObserver,
      getValidationState,
      perPage,
      totalItems,
      currentPage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      perPageOptions,
      tableColumns,
      data,
      freight,
      isCreate,
      isLoaded,
      syncLoad,
      isAdd,
      options,
    }
  },
  computed: {
    hasPermissionToRead() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport_settings.can_read
    },
    hasPermissionToWrite() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport_settings.can_write
    },
    hasPermissionToUpdate() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport_settings.can_edit
    },
    hasPermissionToDelete() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.transport_settings.can_delete
    },
    percentage: {
      get() {
        let valueString = 0

        if (this.freight.value) {
          valueString = this.freight.value.toString()
          valueString = valueString.replace('.', ',')
        }

        return valueString
      },
      set(val) {
        this.freight.value = val
      },
    },
  },
  watch: {
    perPage: 'fetchData',
    currentPage: 'fetchData',
    searchQuery: function updateSearchQuery(value) {
      this.currentPage = 1
      this.searchQuery = value
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      syslic
        .transport
        .freight
        .fetchFreights({
          p: this.currentPage,
          page_size: this.perPage,
          q: this.searchQuery,
        })
        .then(response => {
          this.totalItems = response.data.count
          this.data = response.data.results

          this.syncLoad.ready('freight')
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados das estimativas de frete.',
              text: 'Não foi possível ler os dados das estimativas de frete, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.syncLoad.ready('freight')
        })
    },
    deleteFreight(item) {
      syslic
        .transport
        .freight
        .deleteFreight(item.id)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Estimativa de Frete removida com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.data.splice(this.data.indexOf(item), 1)
        })
        .catch(error => {
          let textError = 'Não foi possível remover esta estimativa de frete, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.detail.includes('they are referenced through protected foreign keys')) {
              textError = 'Esta estimativa de frete é referenciada em algum órgão, por este motivo não será possível remove-lo.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao remover estimativa de frete.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    showConfirmOrCancelDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Por favor, confirme que você deseja remover a estimativa de frete.', {
          id: 'confirmation_box',
          title: 'Confirmar?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-primary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteFreight(item)
          }
        })
    },
    add(val) {
      syslic
        .transport
        .freight
        .addFreight(val)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Estimativa de Frete adicionada com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.fetchData()
          this.setIsCreate(false)
        })
        .catch(error => {
          let textError = 'Não foi possível adicionar esta estimativa de frete, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.includes('duplicate key value violates unique constraint')) {
              textError = 'Já existe uma Estimativa de Frete com este nome, não é possivel adicionar uma estimativa de frete com nome repetido.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao adicionar estimativa de frete.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.setIsCreate(false)
        })
    },
    update(id, val) {
      syslic
        .transport
        .freight
        .updateFreight(id, val)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Estimativa de Frete atualizada com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.fetchData()
        })
        .catch(error => {
          let textError = 'Não foi possível atualizar esta estimativa de frete, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.includes('duplicate key value violates unique constraint')) {
              textError = 'Já existe uma estimativa de frete com este nome, não é possivel atualizar uma estimativa de frete com nome repetido.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao adicionar estimativa de frete.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    edit(item) {
      this.freight = JSON.parse(JSON.stringify(item))
      this.isAdd = false
      this.$refs.modalColorName.show()
    },
    save() {
      if (this.isAdd) {
        this.add(this.freight)
      } else {
        this.update(this.freight.id, this.freight)
      }

      this.isAdd = true
    },
    cancel() {
      this.setIsCreate(false)
      this.freight = {
        name: '',
        value: '',
      }

      this.isAdd = true
    },
    setIsCreate(value) {
      this.isCreate = value
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
      mdiPlus,
      mdiCogOutline,
      mdiTrashCanOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.smallField {
  width: 5px !important;
}

.per-page-selector {
  width: 90px;
}

.dropdownfix .dropdown.show{
  position: fixed;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#cardFreight {
  box-shadow: 0px 1px 30px #0000001a;
  border-radius: 10px;
}

#idModalColorName .vc-slider {
  width: 100% !important;
}

#idModalColorName .modal-footer {
  display: flex !important;
  flex-direction: row-reverse;

  justify-content: end;
  .btn{
    min-width: 107px;
  }
}

#addItemBtn {
  position: fixed;
  right: 0;
  bottom: 0;
}
</style>
